export default __webpack_public_path__ + "static/media/1999.2c10c97b.png";